import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { AuthRepository } from 'app/state/auth.repository';
import { AuthService } from 'app/state/auth.service';

@Component({
    selector: 'app-user-card',
    templateUrl: './user-card.component.html',
    styleUrls: ['./user-card.component.scss'],
    standalone: false
})
export class UserCardComponent implements OnInit {
  readonly DEFAULT_IMAGE = 'assets/img/user_default.svg';

  @Input() size: 'sm' | 'md' | 'lg' = 'lg';
  @Input() preventClick = false;
  @Output() profileClick = new EventEmitter<Event>();

  constructor(
    private auth: AuthService,
    public repo: AuthRepository,
    public generalDataRepo: GeneralDataRepository
  ) {}

  ngOnInit(): void {}
}
